// extracted by mini-css-extract-plugin
export default {"container":"SendMessagePython_container__DllhW","textItem":"SendMessagePython_textItem__t3g8P"};